import React, { Component } from "react";
import { Button } from "antd";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";

@inject("context")
@observer
class WizardFormButtons extends Component {
	static propTypes = {
		tabs: PropTypes.array.isRequired,
	};

	render() {
		const service = this.props.context.tabsService;
		const { tabs } = this.props;

		return (
			<>
				{!service.isOnFirstFormTab && (
					<Button
						className="mr-auto"
						onClick={() => service.goToPreviousFormTab()}
					>
						{"<<"} Back to {tabs[service.previousFormTab].title}
					</Button>
				)}
				{!service.isOnLastFormTab && (
					<Button className="ml-auto" type="primary" htmlType="submit">
						Go to {tabs[service.nextFormTab].title} {">>"}
					</Button>
				)}
				{service.isOnLastFormTab && (
					<Button className="ml-auto" type="primary" htmlType="submit">
						Finish!
					</Button>
				)}
			</>
		);
	}
}

export default WizardFormButtons;
